import {IconName} from '../../../../libs/shared/ui/src/components/icon/icon';
import {InferredType, ResultTypesEnum} from './infer/expressionResultModel';

interface ExpressionIconVariations {
  small: {
    outlined: IconName;
    filled: IconName;
  };
  regular: {
    // outlined: IconName,
    filled: IconName;
  };
}

const expressionTypeIcons: Record<ResultTypesEnum, ExpressionIconVariations> = {
  [ResultTypesEnum.TEAMMATE]: {
    small: {outlined: 'teammateSmall', filled: 'participantFilledSmall'},
    regular: {filled: 'teammateFilled'},
  },
  [ResultTypesEnum.INBOX]: {
    small: {outlined: 'inboxSmall', filled: 'inboxFilledSmall'},
    regular: {filled: 'inboxFilled'},
  },
  [ResultTypesEnum.STRING]: {
    small: {outlined: 'contentSmall', filled: 'contentSmall'},
    regular: {filled: 'content'},
  },
  [ResultTypesEnum.BOOLEAN]: {
    small: {outlined: 'togglesSmall', filled: 'togglesFilledSmall'},
    regular: {filled: 'togglesFilled'},
  },
  [ResultTypesEnum.NUMBER]: {
    small: {outlined: 'numbersSmall', filled: 'numbersSmall'},
    regular: {filled: 'numbers'},
  },
  [ResultTypesEnum.DATETIME]: {
    small: {outlined: 'dateSmall', filled: 'dateFilledSmall'},
    regular: {filled: 'dateFilled'},
  },
  [ResultTypesEnum.LIST]: {
    small: {outlined: 'listSmall', filled: 'listFilledSmall'},
    regular: {filled: 'listFilled'},
  },
  [ResultTypesEnum.CONTACT]: {
    small: {outlined: 'contactsSmall', filled: 'contactsFilledSmall'},
    regular: {filled: 'contactsFilled'},
  },
  [ResultTypesEnum.ACCOUNT]: {
    small: {outlined: 'briefcaseOutlineSmall', filled: 'briefcaseFilledSmall'},
    regular: {filled: 'briefcaseFilled'},
  },
  [ResultTypesEnum.TAG]: {
    small: {outlined: 'tagSmall', filled: 'tagFilledSmall'},
    regular: {filled: 'tagFilled'},
  },
  [ResultTypesEnum.URL]: {
    small: {outlined: 'linkSmall', filled: 'linkSmall'},
    regular: {filled: 'link'},
  },
  [ResultTypesEnum.EMAIL]: {
    small: {outlined: 'messageSmall', filled: 'channelEmailSmall'},
    regular: {filled: 'channelEmail'},
  },
  [ResultTypesEnum.TOPIC]: {
    small: {outlined: 'linkSmall', filled: 'linkSmall'},
    regular: {filled: 'link'},
  },
  [ResultTypesEnum.CONVERSATION]: {
    small: {outlined: 'channelChatOutlineSmall', filled: 'channelChatSmall'},
    regular: {filled: 'channelChat'},
  },
  [ResultTypesEnum.MESSAGE]: {
    small: {outlined: 'messageSmall', filled: 'channelEmailSmall'},
    regular: {filled: 'channelEmail'},
  },
  [ResultTypesEnum.COMMENT]: {
    small: {outlined: 'discussionSmall', filled: 'discussionFilledSmall'},
    regular: {filled: 'chatFilled'},
  },
  [ResultTypesEnum.ACTIVITY]: {
    small: {outlined: 'spamSmall', filled: 'spamFilledSmall'},
    regular: {filled: 'spamFilled'},
  },
  [ResultTypesEnum.CIRCLE]: {
    small: {outlined: 'teammatesSmall', filled: 'teammatesFilledSmall'},
    regular: {filled: 'teammatesFilled'},
  },

  [ResultTypesEnum.UNKNOWN]: {
    small: {outlined: 'spamSmall', filled: 'spamFilledSmall'},
    regular: {filled: 'spamFilled'},
  },
  [ResultTypesEnum.UNDEFINED]: {
    small: {outlined: 'spamSmall', filled: 'spamFilledSmall'},
    regular: {filled: 'spamFilled'},
  },

  // Temporary icons.
  [ResultTypesEnum.AUTOLINKER]: {
    small: {outlined: 'mentionSmall', filled: 'mentionFilledSmall'},
    regular: {filled: 'mention'},
  },
  [ResultTypesEnum.PREVIEWER]: {
    small: {outlined: 'eyeSmall', filled: 'eyeSmall'},
    regular: {filled: 'eyeSmall'},
  },
  [ResultTypesEnum.JSON]: {
    small: {outlined: 'code', filled: 'code'},
    regular: {filled: 'code'},
  },
  [ResultTypesEnum.DATA_TABLE]: {
    small: {outlined: 'tableColumnSmall', filled: 'tableColumnSmall'},
    regular: {filled: 'tableColumn'},
  },
};

export function getExpressionTypeIcon(type: InferredType): ExpressionIconVariations {
  return expressionTypeIcons[type.type] ?? expressionTypeIcons[ResultTypesEnum.UNKNOWN];
}

export function getExpressionTypeDropdownIcon(type: InferredType): IconName {
  return getExpressionTypeIcon(type).small.outlined;
}
